export default __webpack_public_path__ + "static/media/photo01_pc@2x.8973e5ab.jpg";